<template>
  <section>
    <!-- Final submit form Items -->
    <!--<span class="form-step">Step 3 - Fill out the form below</span><br>-->
    <div class="container" v-if="quoteRequest.company">
      <div
        class="page-header"
      >Add any extra information below such as file uploads or payment terms.</div>
      <!--<h3 class="title is-4 _has-text-centered">Details</h3>-->
      <div class="columns" v-show="!reopenVisible">
        <div class="column">
          <h4 class="title is-6">Upload an attachment</h4>
          <label class="file-upload-label">
            <span v-if="!uploading">Select files</span>
            <span v-if="uploading">Uploading files</span>
            <span
              v-if="uploading"
              class="button btn-transparent is-loading white-loader file-upload-spinner"
            ></span>
            <input
              type="file"
              v-show="false"
              id="files"
              ref="files"
              style="height: 0"
              multiple
              v-on:change="handleFilesUpload()"
            >
          </label>
          <span v-if="uploadError" class="has-text-danger">Status: {{uploadError}}</span>

          <ol class="uploads-list">
            <li v-for="(file, index) in files" v-bind:key="index">
              {{file.name}}
              <span v-if="file.success" class="tag has-text-success">Uploaded</span>
              <span v-if="file.error" class="tag has-text-danger">Error</span>
            </li>
          </ol>

          <h4 class="title is-6" v-if="this.uploads.length > 0">Previously uploaded attachments</h4>
          <ol style="padding-left: 20px; margin-left: 0">
            <li
              v-for="(file, index) in uploads"
              v-bind:key="index"
              class="has-text-left is-size-5"
              style="margin: 0 0 10px 0; padding: 4px; background-color: #ececec;"
            >
              <div class="level is-mobile">
                <div class="level-left"><a @click="downloadFile(file)">{{file.fileName}}</a></div>
                <div class="level-right">
                  <button class="button is-danger" type="button" @click="deleteUploadedFile(file, index)">
                    <span class="fa fa-trash"></span>
                  </button>
                </div>
              </div>
            </li>
          </ol>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <strong>CC to</strong>
            <p class="control">
              <input
                class="input _is-static"
                type="text"
                maxlength="50"
                name="emailCC"
                :value="quoteRequest.recipient.emailCC"
                @input="updateRecipientEmailCC"
                v-bind:disabled="reopenVisible"
                placeholder="Additional recipient emails (comma separated)"
              >
            </p>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <strong>Notes</strong>
            <br>
            <p class="control">
              <textarea
                class="textarea _is-static"
                rows="3"
                name="Notes"
                v-validate="{ required: false, min: 3}"
                :value="quoteRequest.recipient.responseText"
                @input="updateRecipientResponseText"
                v-bind:disabled="reopenVisible"
                placeholder="Enter your payment terms here for example"
              ></textarea>
              <span class="has-text-danger">{{ errors.first('Notes') }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script >
import axios from 'axios'

export default {
  name: 'section-form',
  components: {},
  inject: ['$validator'],
  props: [
    'quoteRequest',
    'dateDeadline',
    'dateSubmitted',
    'reopenVisible',
    'submitting',
    'submittedSuccess',
    'token',
    'step',
    'stepReached'
  ],
  mounted () {},
  data () {
    return {
      files: [],
      uploads: this.$store.state.data.recipient.uploads || [],
      prevFiles: [],
      uploading: false,
      uploadError: ''
    }
  },
  methods: {
    updateRecipientResponseText (e) {
      // this.$store.commit('updateRecipientResponseText', e.target.value)
      this.$emit('updateRecipientResponseText', e)
    },
    updateRecipientEmailCC (e) {
      // this.$store.commit('updateRecipientEmailCC', e.target.value)
      this.$emit('updateRecipientEmailCC', e)
    },
    /**
     * VUE-UPLOAD-COMPONENT
     * Has changed
     * @param  Object|undefined   newFile   Read only
     * @param  Object|undefined   oldFile   Read only
     * @return undefined
     */
    inputFile: function (newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        if (newFile.xhr) {
          //  Get the response status code
        }
      }
    },
    /**
     * Pretreatment
     * @param  Object|undefined   newFile   Read and write
     * @param  Object|undefined   oldFile   Read only
     * @param  Function           prevent   Prevent changing
     * @return undefined
     */
    inputFilter: function (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          return prevent()
        }
      }

      // Create a blob field
      newFile.blob = ''
      let URL = window.URL || window.webkitURL
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file)
      }
    },
    clearFiles (index) {
      // this.files.splice(index, 1)
      this.files = []
      // this.prevFiles = []
      // delete this.files.FileList[index]
    },
    /*
        Submits all of the files to the server
      */
    submitFiles () {
      let scope = this
      /*
        Initialize the form data
      */
      let formData = new FormData()

      /*
        Iterate over any file sent over appending the files
        to the form data.
      */
      let newFiles = []
      for (let i = 0; i < this.files.length; i++) {
        let file = this.files[i]
        newFiles.push(file)
        formData.append(`files[${i}]`, file)
      }

      /*
        Make the request to the POST /multiple-files URL
      */
      scope.uploading = true
      scope.uploadError = ''
      axios
        .post(this.postMethod, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${this.id}`
          }
        })
        .then(() => {
          setTimeout(() => {
            scope.uploading = false
            for (let i = 0; i < scope.files.length; i++) {
              let newFile = {'fileName': newFiles[i].name, 'folder': scope.ID_Recipient}
              // scope.prevFiles.push(newFiles[i]);
              scope.uploads.push(newFile)
            }
            scope.files = []
          }, 1500)
          for (let i = 0; i < scope.files.length; i++) {
            scope.files[i].success = true
          }
        })
        .catch(() => {
          scope.uploadError = 'Error with file upload.'
          setTimeout(() => {
            scope.uploading = false
          }, 1500)
          for (let i = 0; i < scope.files.length; i++) {
            scope.files[i].error = true
          }
        })
    },

    /*
      Handles a change on the file upload
    */
    handleFilesUpload () {
      let scope = this
      scope.files = scope.$refs.files.files
      setTimeout(() => { scope.submitFiles() }, 100)
    },

    deleteUploadedFile (file, index) {
      // Route(template: "quoterequest/portal/storage/{container}/deleteAttachment"),
      //  SwaggerResponse(HttpStatusCode.OK)]
      // public async Task<IHttpActionResult> Delete(string container, string quoteRequestId, string fileName)

      if (confirm('Are you sure to delete this file?')) {
        let scope = this
        let remoteUrl = `${
          window.APP_CONFIG.apiServiceUrl
        }quoterequest/portal/storage/documents/deleteAttachment/?quoteRequestId=${
          this.quoteRequest.requestId
        }&fileName=${file.folder}/${file.fileName}`

        axios
          .delete(remoteUrl, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${this.id}`
            }
          })
          .then(() => {
            // Delete the file from the index whenceforth it were at
            scope.uploads.splice(index, 1)
          })
          .catch(() => {
            scope.uploadError = 'Error with file delete.'
            // setTimeout(() => { scope.uploading = false }, 1500)
            // for (let i = 0; i < scope.files.length; i++) {
            //   scope.files[i].error = true
            // }
          })
      }
    },

    downloadFile (file) {
      const AuthStr = `Bearer ${this.id}`
      axios.get(`${file.url}`, {headers: {Authorization: AuthStr}})
        .then(response => {
          // If request is good...
          let url = `${window.APP_CONFIG.apiServiceUrl}metadata/storage/download?token=${encodeURIComponent(response.data)}`
          window.location.href = url
        })
        .catch((error) => {
          console.log('error', error)
        })
    }

  },
  computed: {
    id () {
      return this.$store.state.token
    },
    ID_Recipient () {
      return this.$store.state.data.recipient.iD_QuoteRequestRecipient
    },
    postMethod () {
      return `${
        window.APP_CONFIG.apiServiceUrl
      }quoterequest/portal/storage/documents/uploadAttachment/?recipientId=${
        this.ID_Recipient
      }&quoteRequestId=${this.quoteRequest.requestId}`
    }
  }
}
</script>
